<template>
    <div v-if="show" class="plan">
        <span>
            <span class="plan-name"><el-checkbox v-model="checked">{{data.planName}}</el-checkbox></span>
            <span class="tools">
                <el-button v-if="data.merged" type="text" @click="cancelMerge"><i class="fas fa-unlink"></i> 取消合併</el-button>
                <span>
                    <el-button type="text" @click="toggleRenamePanel"><i class="fas fa-edit"></i> 重新命名</el-button>
                    <span v-if="isShowRenamePanel" class="rename-panel">
                        <span class="rename-content">
                            請輸入新的名稱
                            <el-input class="rename-input" v-model="newName"></el-input>
                            <span class="rename-buttons">
                                <el-button type="primary" @click.native="rename">確定</el-button>
                                <el-button @click.native="toggleRenamePanel">取消</el-button>
                            </span>
                        </span>
                    </span>
                </span>
                <el-button type="text" @click="deletePlan"><i class="fas fa-times-circle"></i> 刪除</el-button>
            </span>
        </span>
        <CompareUnit v-for="{index, compareData} in data.compareUnitDataList"
          :index="index"
          :key="index"
          :compareData="compareData"
          :type="compareData.type"
        ></CompareUnit>
    </div>
</template>

<script>
import CompareUnit from './CompareUnit'

export default {
  name: 'Plan',
  data () {
    return {
      isShowRenamePanel: false,
      newName: ''
    }
  },
  components: {
    CompareUnit
  },
  props: ['index', 'data'],
  computed: {
    checked: {
      get () {
        return this.data.checked
      },
      set (val) {
        this.$emit('checked', { index: this.index, checked: val })
      }
    },
    show () {
      return this.data.compareUnitDataList.length > 0
    },
    // 統整目前內含廣告活動的資料給其他元件呈現
    combinedResult: function () {
      const result = {}
      const platforms = ['mobile', 'desktop']

      platforms.forEach((platform) => {
        result[platform] = this.data.compareUnitDataList.reduce((tmpResult, { compareData }) => {
          const { reachUu, totalUu } = compareData.calculationResult[platform]
          tmpResult.reachUu += reachUu || 0
          tmpResult.totalUu += totalUu || 0

          return tmpResult
        }, { reachUu: 0, totalUu: 0 })
      })
      return result
    }
  },
  methods: {
    cancelMerge () {
      this.$emit('cancelMerge', this.index)
    },
    toggleRenamePanel () {
      this.newName = ''
      this.isShowRenamePanel = !this.isShowRenamePanel
    },
    rename () {
      if (this.newName) {
        this.$emit('rename', { index: this.index, name: this.newName })
        this.toggleRenamePanel()
      }
    },
    deletePlan () {
      this.$confirm('確定要刪除此筆資料?', {
        cancelButtonText: '取消',
        confirmButtonText: '確定'
      }).then(() => {
        this.$emit('delete', this.index)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.plan{
    margin-bottom: 32px;
}
.plan-name>.el-checkbox{
    font-size: 16px;
    font-weight: 600;
}
.tools{
    position: relative;
    float: right;
    margin-right: 20px;
    height: 20px;
    z-index: 100;
    padding: 0;
}
.tools>span{
    font-size: 14px;
    color: #4da1ff;
    margin: 0 10px;
}
.rename-panel{
    color: black;
    position:absolute;
    width: 368px;
    height: 167px;
    top: 32px;
    right: 0px;
    box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
    background-color: #ffffff;
}
.rename-content{
    display: inline-block;
    margin:16px;
}
.rename-input{
    width: 336px;
    height: 40px;
    border-radius: 4px;
    border: solid 1px #c6c6c6;
    background-color: #ffffff;
    margin: 30px auto 16px;
}
.rename-buttons{
    float: right;
}
.fas{
    background-color: red;
    margin-right: 10px;
}
.el-button--text{
    padding:0;
}
</style>
